import axios from 'axios';
import qs from 'qs';

/**
 * Provides an easy way of making a request.
 */
export default class Request {
	static get defaultTimeout() {
		return 15000;
	}

	constructor(options = {}) {
		this.timeout = options.timeout || Request.defaultTimeout;
	}

	invoke(verb, url, data, params, auth, headers, cancelToken) {
		const req = {
			method: verb,
			params,
			url,
			data,
			auth,
			timeout: this.timeout,
			paramsSerializer: p => qs.stringify(p, { indices: false, arrayFormat: 'repeat' })
		};
		if (this.validateStatus) {
			req.validateStatus = this.validateStatus;
		}
		if (cancelToken) {
			req.cancelToken = new axios.CancelToken(cancelToken);
		}

		if (headers) {
			req.headers = headers;
		}
		return axios(req);
	}
}
